import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=df7b13f6&scoped=true"
import script from "./ProductProperty.vue?vue&type=script&lang=ts"
export * from "./ProductProperty.vue?vue&type=script&lang=ts"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=df7b13f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7b13f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df7b13f6')) {
      api.createRecord('df7b13f6', component.options)
    } else {
      api.reload('df7b13f6', component.options)
    }
    module.hot.accept("./ProductProperty.vue?vue&type=template&id=df7b13f6&scoped=true", function () {
      api.rerender('df7b13f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/ProductProperty.vue"
export default component.exports